import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Icon, useDateTimeFormat, useLocalizeMessage } from 'libs.nucleus';
export const DashboardRefreshWidget = ({ lastUpdated, isRefreshing, onRefresh, }) => {
    const translate = useLocalizeMessage();
    const { formatDateTime } = useDateTimeFormat();
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (!isRefreshing) {
                onRefresh();
            }
        }
    };
    const formattedLastUpdated = lastUpdated ? formatDateTime(lastUpdated) : null;
    return (_jsxs("button", { type: 'button', className: 'flex items-center gap-2 text-sm text-neutral-600 hover:text-text-primary disabled:cursor-not-allowed disabled:opacity-50', onClick: onRefresh, onKeyDown: handleKeyDown, disabled: isRefreshing, "data-testid": 'dashboard-refresh-widget', "aria-busy": isRefreshing, "aria-label": translate('Refresh dashboard data'), children: [formattedLastUpdated && (_jsxs("span", { "data-testid": 'dashboard-last-updated', children: [translate('Last updated'), ": ", formattedLastUpdated] })), _jsx(Icon, { name: 'change', size: 'sm', animation: isRefreshing ? 'spin' : undefined })] }));
};
